import React, { useEffect, useState } from 'react';
import {
    CameraOutlined,
    ProfileOutlined,
    TeamOutlined,
    UsergroupAddOutlined,
    FolderOutlined,
    TagsOutlined,
    RiseOutlined,
    BarChartOutlined,
    ShakeOutlined,
    UserOutlined,
    FileTextOutlined,
    HeatMapOutlined,
    CodeSandboxOutlined,
    OneToOneOutlined,
    PrinterOutlined,
    StockOutlined,
    FundOutlined,
    AimOutlined,
    AuditOutlined,
    CloseCircleOutlined,
    FileSearchOutlined,
    WarningOutlined,
} from '@ant-design/icons';
import reshootIcon from '../assets/images/reshootIcon.svg';
import { Layout, Menu } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';
const { Sider } = Layout;

export default function Sidebar({ user }) {
    const [sideHeight, setSideHeight] = useState('');
    const [activeBar, setActiveBar] = useState('dashboard');
    const navigate = useNavigate();
    const location = useLocation();

    const sideList = [
        {
            name: 'Dashboard',
            path: '',
            key: 'dashboard',
            icon: ProfileOutlined,
            children: [],
        },
        {
            name: 'Rejections',
            path: '',
            key: 'rejections',
            icon: CloseCircleOutlined,
            aclName: 'Dashboard',
        },
        {
            name: 'Client',
            path: '',
            key: 'allClients',
            icon: TeamOutlined,
            children: [],
        },
        {
            name: 'Studio',
            path: '',
            key: 'allStudio',
            icon: CameraOutlined,
        },
        {
            name: 'Tasks',
            path: '',
            key: 'tasksList',
            icon: FolderOutlined,
        },
        {
            name: 'Models',
            path: '',
            key: 'allModels',
            icon: UsergroupAddOutlined,
        },
        {
            name: 'Supporting Articles',
            path: '',
            key: 'allSupportingArticles',
            icon: FolderOutlined,
        },
        {
            name: 'Swatches',
            path: '',
            key: 'Swatches',
            icon: TagsOutlined,
        },
        {
            name: 'Style & Color Library',
            path: '',
            key: 'styleColorLibrary',
            icon: FolderOutlined,
        },
        {
            name: 'Live Shoot',
            path: '',
            key: 'LiveShoots',
            icon: RiseOutlined,
        },
        {
            name: 'Live Shoot Old',
            path: '',
            key: 'LiveShootsOld',
            icon: RiseOutlined,
            aclName: 'Live Shoot',
        },
        {
            name: 'Live PII',
            path: '',
            key: 'LivePii',
            icon: StockOutlined,
        },
        {
            name: 'Live Outbound',
            path: '',
            key: 'LiveOutbound',
            icon: FundOutlined,
        },
        {
            name: 'Live Boxes',
            path: '',
            key: 'LiveBoxes',
            icon: CodeSandboxOutlined,
            aclNames: ['Live Outbound', 'Live PII', 'Pending Audit'],
        },
        {
            name: 'Guidelines',
            path: '',
            key: 'guidelines',
            icon: TagsOutlined,
        },
        {
            name: 'Skus',
            path: '',
            key: 'eans',
            icon: TagsOutlined,
        },
        {
            name: 'Planning',
            path: '',
            key: 'planning',
            icon: BarChartOutlined,
        },
        {
            name: 'Reports',
            path: '',
            key: 'reports',
            icon: FileSearchOutlined,
            aclName: 'Dashboard',
        },
        {
            name: 'Requests',
            path: '',
            key: 'requests',
            icon: ShakeOutlined,
        },
        {
            name: 'Users',
            path: '',
            key: 'users',
            icon: UserOutlined,
        },
        {
            name: 'CSV Generator',
            path: '',
            key: 'csvtool',
            icon: FileTextOutlined,
        },
        {
            name: 'Order CSV',
            path: '',
            key: 'order-csv-data',
            icon: FileSearchOutlined,
            aclName: 'Dashboard',
        },
        {
            name: 'SKU Issues',
            path: '',
            key: 'sku-issues',
            icon: WarningOutlined,
            aclName: 'Dashboard',
        },
        {
            name: 'Shoot Preparation',
            path: '',
            key: 'shootpreparation',
            icon: HeatMapOutlined,
        },
        {
            name: 'Outbound',
            path: '',
            key: 'outbound',
            icon: CodeSandboxOutlined,
        },
        {
            name: 'Draft PII',
            path: '',
            key: 'draftpii',
            icon: OneToOneOutlined,
        },
        {
            name: 'PrintLabelPage',
            path: '',
            key: 'printlabelpage',
            icon: PrinterOutlined,
        },
        {
            name: 'CSACartList',
            path: '',
            key: 'csa-cart-list',
            icon: FolderOutlined,
        },
        {
            name: 'Tracker',
            path: '',
            key: 'tracker',
            icon: AimOutlined,
        },
        { name: 'Expected Shipments', key: 'expected-shipments', icon: FolderOutlined },
        { name: 'Received Shipments', key: 'received-shipments', icon: FolderOutlined },
        { name: 'Manpower', key: 'manpower', aclName: 'Minibatching Performance', icon: TeamOutlined },
        { name: 'Minibatching Performance', key: 'minibatch-performance', icon: BarChartOutlined },
        { name: 'Raw QC Performance', key: 'rawqc-performance', icon: BarChartOutlined },
        { name: 'Assignment Performance', key: 'assignment-performance', aclName: 'Raw QC Performance', icon: BarChartOutlined },
        { name: 'Ready To Pack', key: 'ready-to-pack', icon: CodeSandboxOutlined },
        { name: 'Pending Audit', key: 'pending-audit', icon: FundOutlined },
        { name: 'Audit Approvals', key: 'audit-approvals', icon: AuditOutlined },
        { name: 'Audited Outbound', key: 'audited-outbound', icon: StockOutlined },
        { name: 'Studio Operations', key: 'studio-operations', aclName: 'Studio Operations', icon: FundOutlined },
        { name: 'Revenue', key: 'revenue', aclName: 'Revenue', icon: FundOutlined },
        { name: 'Rate Cards', key: 'rate-cards', aclName: 'Revenue', icon: TagsOutlined },
    ];

    const items2 = sideList
        ?.filter(d => {
            const names = [d.name, d.aclName, ...(d.aclNames || [])];
            return names.some(name => name && user?.components?.includes(name));
        })
        ?.map((item, index) => {
            const key = String(index + 1);
            return {
                key: `${item.key}`,
                icon: React.createElement(item.icon),
                label: item.name,
                title: item.name,
            };
        });

    const sideBarHandler = e => {
        navigate(`${e?.key}`);
    };
    useEffect(() => {
        setSideHeight(window.innerHeight - document.getElementById('headerBar')?.clientHeight);
        setActiveBar(location?.pathname?.split('/')[1]);
        if (!location?.pathname?.split('/')[1]) {
            setActiveBar('dashboard');
        }
    }, [document.getElementById('headerBar'), location]);

    return (
        <div className="sidebar-main">
            <Sider
                width={250}
                style={
                    {
                        // boxShadow: "1px 0px 4px -1px rgb(0 0 0 / 75%)",
                        // height: `${sideHeight-1}px`
                        // height: `90.5vh`,
                    }
                }
            >
                <Menu
                    mode="inline"
                    selectedKeys={[activeBar]}
                    onClick={e => sideBarHandler(e)}
                    style={{
                        boxShadow: '1px 0px 4px -1px rgb(0 0 0 / 75%)',
                        // height: `${sideHeight-1}px`
                        height: `90.5vh`,
                        overflow: 'auto',
                    }}
                    items={items2}
                />
            </Sider>
        </div>
    );
}
